module.exports = __webpack_public_path__ + "img/多彩贵州线下攻略.e6ed1c49.png";